export enum LOAN_ACCESS_TYPE {
  CALCULATION,
  LOAN_APPLY,
}

export enum LOAN_PRODUCT_TYPE {
  SMARTMONEY = 'DL_SMARTMONEY',
  PAYDAY = 'DL_PAYDAY',
  THUNGNGERN = 'DL_THUNGNGERN',
}
